import LoginForm from '@/components/PageSpecific/login/LoginForm';
import TrusteLogo from '@/components/PageSpecific/login/TrusteLogo/TrusteLogo';
import { IS_ETS_NEXT, IS_ETS_NEXT_PROD } from '@/utils/constants';
import { Box, Button, Divider, Typography } from '@mui/material';
import moment from 'moment-timezone';
import Image from 'next/image';

export default function LoginStep({
  formData,
  handleInputChange,
  loading,
  handleLoginSubmit,
  handleKeycloakLogin,
  onOpenPP,
  onOpenTOU,
}) {
  return (
    <Box sx={{ mb: 0 }}>
      <Typography
        component='h1'
        variant='h1'
        sx={(theme) => ({
          fontWeight: theme.typography.fontWeightBold,
          color: theme.palette.text.primary,
          textAlign: 'center',
          mb: 3,
          fontSize: { xs: '1.5rem', sm: '2rem' },
        })}
      >
        Log In
      </Typography>
      {!IS_ETS_NEXT_PROD && (
        <LoginForm
          formData={formData}
          handleInputChange={handleInputChange}
          loading={loading}
          handleLoginSubmit={handleLoginSubmit}
        />
      )}

      {IS_ETS_NEXT && (
        <Button
          onClick={handleKeycloakLogin}
          color='primary'
          variant='contained'
          fullWidth
          disabled={loading}
          startIcon={
            <Image
              src='/images/keycloak.png'
              alt='Keycloak Icon'
              width={24}
              height={24}
            />
          }
          sx={{ mt: 2, mb: 2 }}
        >
          Login with Keycloak
        </Button>
      )}
      <Divider sx={{ mt: 2, mb: 1 }} />

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-around',
        }}
      >
        <Button
          onClick={onOpenPP}
          variant='text'
          style={{ backgroundColor: 'transparent' }}
        >
          <Typography sx={(theme) => ({ color: theme.palette.text.primary })}>
            Privacy policy
          </Typography>
        </Button>
        <Button
          onClick={onOpenTOU}
          variant='text'
          style={{ backgroundColor: 'transparent' }}
        >
          <Typography sx={(theme) => ({ color: theme.palette.text.primary })}>
            Terms of use
          </Typography>
        </Button>
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          mt: 2,
        }}
      >
        <TrusteLogo />
      </Box>
      <Typography
        sx={(theme) => ({
          mt: 2,
          fontSize: '12px',
          textAlign: 'center',
          color: theme.palette.text.primary,
        })}
      >
        © {moment().year()} Cornerstone Information Systems, Inc.
      </Typography>
    </Box>
  );
}
